module.exports = __webpack_public_path__ + "static/img/9.0edb1e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Cumplimiento-Disposiciones-Legales/9.png
// module id = Ua/k
// module chunks = 0